"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TuttiLoginListenerStatus = exports.TuttiSignInStatus = exports.TuttiLoginVerificationMode = exports.TuttiLoginRequestMode = exports.UserSignInRequestMode = void 0;
/**
 * Enum for the different sign in request types
 * NOTIFICATION used for requests from web using number
 * QR_CODE used for tutti login & web login using QR-code
 */
var UserSignInRequestMode;
(function (UserSignInRequestMode) {
    UserSignInRequestMode[UserSignInRequestMode["NOTIFICATION"] = 0] = "NOTIFICATION";
    UserSignInRequestMode[UserSignInRequestMode["QR_CODE"] = 1] = "QR_CODE";
    UserSignInRequestMode[UserSignInRequestMode["CODE"] = 2] = "CODE";
})(UserSignInRequestMode = exports.UserSignInRequestMode || (exports.UserSignInRequestMode = {}));
/**
 * Enum for creating the request for tutti-login
 * NOTIFICATION used for logging in using tutti as verifier
 * QR used for tutti to sign in via qr-code
 */
var TuttiLoginRequestMode;
(function (TuttiLoginRequestMode) {
    TuttiLoginRequestMode[TuttiLoginRequestMode["NOTIFICATION_SP"] = 0] = "NOTIFICATION_SP";
    TuttiLoginRequestMode[TuttiLoginRequestMode["NOTIFICATION_TW"] = 1] = "NOTIFICATION_TW";
    TuttiLoginRequestMode[TuttiLoginRequestMode["QR_REQUEST"] = 2] = "QR_REQUEST";
    TuttiLoginRequestMode[TuttiLoginRequestMode["CODE_SP"] = 3] = "CODE_SP";
    TuttiLoginRequestMode[TuttiLoginRequestMode["CODE_TW"] = 4] = "CODE_TW";
    TuttiLoginRequestMode[TuttiLoginRequestMode["CODE_TA"] = 5] = "CODE_TA";
})(TuttiLoginRequestMode = exports.TuttiLoginRequestMode || (exports.TuttiLoginRequestMode = {}));
/**
 * Enum for verifying requests
 * NOTIFICATION used for sending response from prompt in tutti, accepting or denying
 * QR_VERIFY used to verify sign in to web using tutti in-app camera.
 * QR_CREATE used to create an authorized sign in to users' account via QR-code scanned.
 */
var TuttiLoginVerificationMode;
(function (TuttiLoginVerificationMode) {
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["NOTIFICATION_TW"] = 0] = "NOTIFICATION_TW";
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["NOTIFICATION_SP"] = 1] = "NOTIFICATION_SP";
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["QR_VERIFY"] = 2] = "QR_VERIFY";
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["QR_CREATE"] = 3] = "QR_CREATE";
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["CODE_SP"] = 4] = "CODE_SP";
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["CODE_TW"] = 5] = "CODE_TW";
    TuttiLoginVerificationMode[TuttiLoginVerificationMode["CODE_TA"] = 6] = "CODE_TA";
})(TuttiLoginVerificationMode = exports.TuttiLoginVerificationMode || (exports.TuttiLoginVerificationMode = {}));
/**
 * INITIALIZED: notification or qr request has been made
 * ACCEPTED: User has approved login request,
 * DECLINED: User has declined login request,
 */
var TuttiSignInStatus;
(function (TuttiSignInStatus) {
    TuttiSignInStatus[TuttiSignInStatus["INITIALIZED"] = 0] = "INITIALIZED";
    TuttiSignInStatus[TuttiSignInStatus["ACCEPTED"] = 1] = "ACCEPTED";
    TuttiSignInStatus[TuttiSignInStatus["DECLINED"] = 2] = "DECLINED";
})(TuttiSignInStatus = exports.TuttiSignInStatus || (exports.TuttiSignInStatus = {}));
/**
 * INITIALIZED: Someone has initialized login
 * COMPLETED: Login is ready, token can be fetched from callable
 * DECLINED: Login was declined or invalidated
 */
var TuttiLoginListenerStatus;
(function (TuttiLoginListenerStatus) {
    TuttiLoginListenerStatus[TuttiLoginListenerStatus["INITIALIZED"] = 0] = "INITIALIZED";
    TuttiLoginListenerStatus[TuttiLoginListenerStatus["COMPLETED"] = 1] = "COMPLETED";
    TuttiLoginListenerStatus[TuttiLoginListenerStatus["DECLINED"] = 2] = "DECLINED";
})(TuttiLoginListenerStatus = exports.TuttiLoginListenerStatus || (exports.TuttiLoginListenerStatus = {}));
//# sourceMappingURL=tuttilogin.js.map